<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Cashier Transaction') }}</span>
            </v-layout>
          </h3>

          <v-spacer />

          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2>
              <p>{{ `${$t('Currency Type')} *` }}</p>
              <v-radio-group
                v-model="form.currency_type"
                name="currency_type"
                v-validate="'required'"
                row
                @change="newBalance"
              >
                <v-radio :label="$t('USD')" value="USD" color="blue" />
                <v-radio :label="$t('IQD')" value="IQD" color="blue" />
              </v-radio-group>
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                :value="form.currency_type === 'USD' ? cashierInfo.begin_us : cashierInfo.begin_iq"
                :label="`${$t('Begin Balance')} *`"
                name="begin"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('begin')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                :value="form.currency_type === 'USD' ? cashierInfo.amount_us : cashierInfo.amount_iq"
                :label="`${$t('Current Balance')} *`"
                name="balance"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('balance')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs12 pa-2>
              <p>{{ `${$t('Transaction Type')} *` }}</p>
              <v-radio-group
                v-model="form.transaction_type"
                name="transaction_type"
                v-validate="'required'"
                row
                @change="newBalance"
              >
                <v-radio :label="$t('To Cash')" value="To Cash" color="blue" />
                <v-radio :label="$t('To Cashier')" value="To Cashier" color="blue" />
              </v-radio-group>
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                id="main-cashier-transaction-focus-me"
                v-model="form.amount"
                :label="`${$t('Amount')} *`"
                name="amount"
                box
                hide-details
                background-color="white"
                :error="errors.has('amount')"
                v-validate="'required|decimal|min_value:0'"
                @input="newBalance"
              />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                v-model="form.balance_after_transaction"
                :label="`${$t('Balance After Transaction')} *`"
                name="balance_after_transaction"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('balance_after_transaction')"
                v-validate="'required'"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',
  props: {
    addDialog: { type: Boolean, required: true },
    cashierInfo: { type: Object, required: true }
  },

  data() {
    return {
      dateMenu: false,
      btnAddLoading: false,
      form: {
        currency_type: '',
        transaction_type: '',
        amount: 0,
        balance_after_transaction: '',
        balance_before_transaction: '',
        depositor_id_fk: null
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      fullStaffList: 'staff/getFullStaffsList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  mounted() {
    this.setFullStaffList()
  },

  methods: {
    ...mapActions({
      addCashier: 'cashierTransactions/addTransaction',
      setFullStaffList: 'staff/setFullStaffsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.currency_type = 'USD'
      this.form.current_balance = 0

      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('main-cashier-transaction-focus-me').focus()
      })
    },

    newBalance() {
      const current = this.form.currency_type === 'USD' ? this.cashierInfo.amount_us : this.cashierInfo.amount_iq

      const amount = this.form.transaction_type === 'To Cash' ? -this.form.amount : this.form.amount
      this.form.balance_after_transaction = Number(amount) + current
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('main_cashier_id_fk', this.cashierInfo.main_cashier_id)
            formData.append('cashier_user_id_fk', this.cashierInfo.user_id_fk)

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addCashier(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
                this.fetchLastDollarPrice()
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
